import React, {Component} from 'react';
import ParticipantsList from './ParticipantsList';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { fetchParticipants } from '../../actions';
import styled from 'styled-components';
import LogoImg from './bicamsinlogo.jpg';
import NormalImg from '../common/Img';
import Button from '../common/Button';
import TextFieldGroup from '../common/TextFieldGroup';

const Img = styled(NormalImg)`
  width: 300px;
  margin: 20px;
  display: block;
`;

const ButtonA = styled(Button)`
  background: #324971;
  color: #fff;
`;
const ButtonB = styled(Button)`
  background: #7A062D;
  color: #fff;
`;

class ParticipantsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      participants: {},
      searchText: '',
      errors: {},
      isLoading: false,
    };

    this.handleSearch = this.handleSearch.bind(this);
    this.onChange = this.onChange.bind(this);
  }
  onChange(e){
    this.setState({ [e.target.name]: e.target.value });
  }
  handleSearch() {
    
  }
  componentDidMount() {
    this.setState({errors: {}, isLoading: true});
    this.props.fetchParticipants();//.then(
    //   (res) => this.setState({participants: res.participants, isLoading: false}),
    //   (err) => this.setState({errors: err, isLoading: false})
    // );
  }
  render() {
    const { searchText, errors } = this.state;
    return (
      <div className="normalPage">
        <div className="container">
          <div className="row">
            <div className="col-xs-6">
              <Img src={LogoImg} alt="Bicams Logo" />
            </div>
            <div className="col-xs-6">
              <Link to="/new_participant"><ButtonA className="btn btn-lg">Add New Participant</ButtonA></Link>
              <Link to="/logout"><ButtonB className="btn btn-lg">Logout</ButtonB></Link>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-6">
              <h2 className="bicamsColor">Your BICAMS Participants</h2>
            </div>
            <div className="col-xs-6">
              <form className="form-inline">
                <TextFieldGroup
                  field="searchText"
                  placeholder="Search BICAMS Number"
                  value={searchText}
                  onChange={this.onChange}
                  error={errors.search}
                  type="text"
                  classes="borderInput"
                />
                <ButtonA className="btn btn-lg" type="button" onClick={this.handleSearch}>Search</ButtonA>
              </form>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <ParticipantsList participants={this.props.participants} searchText={searchText} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ParticipantsPage.propTypes ={
  participants: React.PropTypes.array.isRequired,
}

function mapStateToProps(state){
  return {
    participants: state.participants
  }
}

export default connect(mapStateToProps, { fetchParticipants })(ParticipantsPage);



// WEBPACK FOOTER //
// ./src/components/participants/ParticipantsPage.js